import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { map, startWith, tap } from 'rxjs/operators';
import { OffersService } from '../../../services/offers.service';
import { Tag } from '../../../interfaces/tag';
import { RESTDataSource } from '../../../helpers/rest.datasource';
import { OfferIface } from '../../../interfaces/offer.iface';
import { MatPaginator } from '@angular/material';
import { LoggerService } from '../../../services/logger.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { OffersMassEditionService } from '../../../services/offers-mass-edition.service';
import { ToastsManager } from 'ng2-toastr';
import { isEqual } from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-offer-withdrawn',
  templateUrl: './offer-withdrawn.component.html',
  styleUrls: ['./offer-withdrawn.component.scss']
})
export class OfferWithdrawnComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  public dataSource: RESTDataSource<OfferIface>;
  public displayedColumns = [
    'name',
    'availableSince',
    'availableUntil',
    'availableInLocations',
    'availableInChannels',
    'availableForCustomerSegments',
    'code',
    'linkToTermsOfService',
    'price',
    'period',
    'activationPrice'
  ];
  public isLoadingResults = false;
  public subscription: Subscription;
  public filteredOptions: Observable<Tag[]>;
  public formFilter: FormControl = new FormControl();
  public tagList: Tag[] = [];
  public activeTags: Tag[] = [];

  constructor(
    private offersService: OffersService,
    private offersMassEditionService: OffersMassEditionService,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    LoggerService.log('OfferListComponent::onInit');
    this.dataSource = new RESTDataSource(this.offersService);
    this.subscription = this.dataSource.loading$.subscribe(state => {
      this.isLoadingResults = state;
    });
    this.paginator.pageSize = 10;
    this.loadData();
    this.filteredOptions = this.formFilter.valueChanges.pipe(
      startWith(''),
      map(val => this.filter(val))
    );
  }

  ngAfterViewInit() {
    LoggerService.log('OfferWithdrawnComponent::ngAfterViewInit');
    this.paginator.page.pipe(tap(() => this.loadData())).subscribe();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  filter(val: string): Tag[] {
    return this.tagList.filter(option =>
      option.value
        .toLowerCase()
        .trim()
        .includes(val.toLowerCase())
    );
  }

  toggleTag(tag: Tag): void {
    const tagIndex = this.activeTags.findIndex(activeTag => isEqual(activeTag, tag));
    if (tagIndex > -1) {
      this.activeTags.splice(tagIndex, 1);
    } else {
      this.activeTags.push(tag);
    }
    this.loadData();
  }

  loadData() {
    const activeTags = this.activeTags.map(tag => tag.value);
    let query = activeTags.length ? { 'tags.value': { $all: activeTags } } : {};
    query = Object.assign(query, {
      offerStatus: 'withdrawn'
    });
    this.dataSource.loadData(query, this.paginator.pageIndex, this.paginator.pageSize, 'status');
    this.offersService.findTags(query).subscribe(tags => {
      this.tagList = tags;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/offer-withdrawn/offer-withdrawn.component.ts